// extracted by css-extract-rspack-plugin
export default {"benefitsList":"benefits-list--fZv7OKVRTAQknZZ0"};